import React from 'react';
import PropTypes from 'prop-types';
import {
  FiHome, FiPackage,
} from 'react-icons/fi';
import { NavLink } from 'react-router-dom';

function PosMenu({ closeMenu }) {
  const handleClick = () => {
    if (closeMenu) closeMenu(); // only used on mobile
  };
  return (
    <div className="bg-gray-800 text-white w-64 min-h-screen p-4">
      <h2 className="text-xl font-bold mb-6 p-2 border-b border-gray-700 flex items-center">
        <FiPackage className="mr-2" />
        Point of Sale
      </h2>

      <MenuItem
        onClick={handleClick}
        to="/pos/dashboard"
        className="flex items-center p-2 rounded hover:bg-gray-700 transition"
        icon={<FiHome />}
        label="Dashboard"
      />
      <MenuItem
        onClick={handleClick}
        to="/pos/pos-screen"
        className="flex items-center p-2 rounded hover:bg-gray-700 transition"
        icon={<FiPackage className="mr-3" />}
        label="POS Screen"
      />
      <MenuItem
        onClick={handleClick}
        to="/pos/pos-returns"
        className="flex items-center p-2 rounded hover:bg-gray-700 transition"
        icon={<FiPackage className="mr-3" />}
        label="POS Returns"
      />
      <MenuItem
        onClick={handleClick}
        to="/pos/pos-settings"
        className="flex items-center p-2 rounded hover:bg-gray-700 transition"
        icon={<FiPackage className="mr-3" />}
        label="POS Settings"
      />
      {/* Add more POS related links here */}
    </div>
  );
}

// Extracted Menu Item Component
function MenuItem({
  to, className, icon, label,
}) {
  return (
    <NavLink
      onClick={onclick}
      to={to}
      className={({ isActive }) => `${className} ${isActive ? 'bg-gray-700' : ''}`}
    >
      {icon}
      <span className="ml-2">{label}</span>
    </NavLink>
  );
}

// Props validation for MenuItem
MenuItem.propTypes = {
  to: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
  icon: PropTypes.node.isRequired,
  label: PropTypes.string.isRequired,
};

// PropTypes

PosMenu.propTypes = {
  closeMenu: PropTypes.func, // optional, used for mobile drawer
};

// Default props to satisfy react/require-default-props
PosMenu.defaultProps = {
  closeMenu: () => {},
};

export default PosMenu;
